import PropTypes from 'prop-types'
import React from 'react'

export const Model = ({title}) => (
  <h1 className='oglasi-headline-model'>{title}</h1>
)

Model.propTypes = {
  title: PropTypes.string.isRequired
}
